import { FC, useEffect, useMemo, useState } from 'react';

import { useMatchXeroPopupQueryParams } from '../../../../../resources/hooks/useMatchXeroPopupQueryParams';
import { Content } from '../Content/Content';
import type { ContentProps } from '../Content/Content.types';

export const MatchContent: FC<ContentProps> = (props) => {
    const { bankAccounts, isLoading, form } = props;

    const [bankAccountBeenSelected, setBankAccountBeenSelected] = useState(false);
    const { bankAccountId } = useMatchXeroPopupQueryParams();

    const bankAccountIdToSelect = useMemo(() => {
        const firstUnmatchedBankAccount = bankAccounts.find((bankAccount) => !bankAccount.xeroBankAccount?.id);

        if (firstUnmatchedBankAccount) {
            return firstUnmatchedBankAccount.id;
        }

        // If we are trying to connect previously connected BAs, we might
        // encounter a scenario where we have a new BA that was matched before.
        // We want to select at least what we already have.
        return bankAccounts[0]?.id;
    }, [bankAccounts]);

    useEffect(() => {
        if (!isLoading && bankAccountIdToSelect && !bankAccountBeenSelected) {
            form.setValue('bankAccountId', bankAccountIdToSelect);
            setBankAccountBeenSelected(true);
        }
    }, [
        form,
        isLoading,
        bankAccountBeenSelected,
        bankAccountIdToSelect,
        // rerun the useEffect on every popup manual reopen as well
        bankAccountId,
    ]);

    // we are selecting one unmatched BA on every popup opening. Since popup is always mounted,
    // we are rely on `bankAccountId` as a reset marker for component states
    useEffect(
        () => () => {
            setBankAccountBeenSelected(false);
        },
        [bankAccountId]
    );

    return <Content {...props} />;
};

MatchContent.displayName = 'MatchContent';
